import React from "react";
import "./translitration.css";
import SNavbar from "../../components/SNavbar";
import { LeftArrow } from "../../assets/SvgIcons";
import { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Img1 from "./../../assets/portfolio/music1.jpg";
import Img2 from "./../../assets/portfolio/music2.png";
import Img3 from "./../../assets/portfolio/music3.png";
import Img4 from "./../../assets/portfolio/music4.png";
import Img5 from "./../../assets/portfolio/music5.png";

import MusicListPlayer from "../../components/musicplayer/Musicplayer";
import music1 from "./../../assets/music/music1.mp3";
import music2 from "./../../assets/music/music2.mp3";
import music3 from "./../../assets/music/music3.mp3";
import music4 from "./../../assets/music/music4.mp3";
import music5 from "./../../assets/music/music5.mp3";
import music6 from "./../../assets/music/music6.mp3";
import { useTranslation } from "react-i18next";

const AllTracks = () => {
  const { t } = useTranslation();
  const tracks = [
    { title: "Song 1", src: music1, artist: "Artist 1", trackTitle: "Song 1", artwork: Img1  },
    { title: "Song 2", src: music2,artist: "Artist 1", trackTitle: "Song 1", artwork: Img1  },
    { title: "Song 3", src: music3 ,artist: "Artist 1", trackTitle: "Song 1", artwork: Img1 },
    { title: "Song 4", src: music4, artist: "Artist 1", trackTitle: "Song 1", artwork: Img1  },
    { title: "Song 5", src: music5, artist: "Artist 1", trackTitle: "Song 1", artwork: Img1  },
    { title: "Song 6", src: music6,artist: "Artist 1", trackTitle: "Song 1", artwork: Img1  },
  ];
  let sliderRef = useRef(null);
  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <SNavbar
        title={t("Created at Roger")}
        actionBTN={<LeftArrow />}
        path={"/tracks"}
      />
      <div className="translitration-container all-tracks">
        <div className="wrapper">
          <div className="">
            <div className="w-100 d-flex justify-content-between items-start Studio-section-crousel ">
              <h4>Виконавці</h4>
              <div className=" d-flex justify-content-end align-items-center gap-3 ">
                <div className="left-btn" onClick={previous}>
                  <SVGLeft />
                </div>
                <div className="left-btn" onClick={next}>
                  <SVGRight />
                </div>
              </div>
            </div>

            <div className="slider-container">
              <Slider
                ref={(slider) => {
                  sliderRef = slider;
                }}
                {...settings}
              >
                <div key={1} className="Slider-card h-100">
                  <img src={Img1} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>Translitertion</h3>
                    <p>Rock</p>
                  </div>
                </div>
                <div key={2} className="Slider-card h-100">
                  <img src={Img2} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>Rozpach</h3>
                    <p>Rock</p>
                  </div>
                </div>
                <div key={3} className="Slider-card h-100">
                  <img src={Img3} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>TaRIK</h3>
                    <p>Rock</p>
                  </div>
                </div>
                <div key={4} className="Slider-card h-100">
                  <img src={Img4} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>Нескорені</h3>
                    <p>Rock</p>
                  </div>
                </div>
                <div key={5} className="Slider-card h-100">
                  <img src={Img5} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>Danvdele</h3>
                    <p>Rock</p>
                  </div>
                </div>
                <div key={6} className="Slider-card h-100">
                  <img src={Img3} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>Нескорені</h3>
                    <p>Rock</p>
                  </div>
                </div>
                <div key={7} className="Slider-card h-100">
                  <img src={Img4} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>Rozpach</h3>
                    <p>Rock</p>
                  </div>
                </div>
              </Slider>
            </div>
          </div>

          <h2>Всі Треки </h2>
          <div className="all-tracks-slider">
            <MusicListPlayer tracks={tracks} />
         
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default AllTracks;
export const SVGLeft = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14 19L7 12L14 5"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SVGRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.99976 5L16.9998 12L9.99976 19"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
